/**
 * Global Navigation Helper
 * Enables non-React functions (like Socket listeners and toast callbacks)
 * to navigate without exporting variables from App.jsx (which breaks Vite HMR).
 */

let globalNavigateFn = null;

export const setGlobalNavigate = (navigate) => {
  globalNavigateFn = navigate;
};

export const navigateTo = (path) => {
  if (globalNavigateFn) {
    globalNavigateFn(path);
  } else {
    window.location.href = path;
  }
};
